import { COMMUNITY_SOURCE_VALIDATION_STATUSES, COMMUNITY_STATUS, SEGMENTS } from '../constants';

const Views = self => ({
  get isCommunityMember() {
    return self.isComposeEnabled && self.isCommunityTermsAccepted;
  },

  get isLeftCommunity() {
    return self.status === COMMUNITY_STATUS.LEFT_COMMUNITY;
  },

  get isInactiveCommunity() { // means disconnected source
    return self.status === COMMUNITY_STATUS.INACTIVE_COMMUNITY_MEMBER;
  },

  get isCommunityCandidate() {
    return self.status === COMMUNITY_STATUS.COMMUNITY_CANDIDATE;
  },

  get isIrrelevantCommunityUser() {
    return self.status === COMMUNITY_STATUS.COMMUNITY_IRRELEVANT;
  },

  get hideEmailCompose() {
    return self.isOutlookDesktopConnected && self.isCommunityMember;
  },

  get isRegistrationInProgress() {
    return self.status === COMMUNITY_STATUS.COMMUNITY_CANDIDATE && (self.isCommunityTermsAccepted || self.firstCommunityTabVisit);
  },

  get isOutlookExeDownloaded() {
    return !!self.outlookExeDownloadDate;
  },

  get isCQL() {
    return self.segment === SEGMENTS.cql;
  },

  get isCommunityPendingSV() {
    return self.sourceValidationStatus === COMMUNITY_SOURCE_VALIDATION_STATUSES.PENDING;
  },

  get isSVFailed() {
    return self.sourceValidationStatus === COMMUNITY_SOURCE_VALIDATION_STATUSES.FAIL;
  },

});

export default Views;
